<template>
  <div>
    <span id="loading" v-if="this.load == true">
      <loading />
    </span>
    <form v-on:submit.prevent="addCandidature()">
      <div class="vld-parent"></div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          placeholder="Nome*"
          v-model="name"
          required
        />
      </div>
      <div class="form-group">
        <input
          class="form-control"
          placeholder="Email*"
          v-model="email"
          required
        />
      </div>
      <div class="form-group">
        <input
          type="number"
          class="form-control"
          placeholder="Telefone*"
          v-model="cellphone"
        />
      </div>
      <div class="form-group">
        <multiselect
          placeholder="Selecione as suas competências"
          v-model="selected"
          deselect-label="Can't remove this value"
          track-by="text"
          label="text"
          :options="options"
          :multiple="true"
        >
        </multiselect>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          v-model="skills"
          placeholder="Outras competências"
        />
      </div>
      <div class="form-group">
        <input
          type="link"
          class="form-control"
          v-model="linkedin"
          placeholder="Perfil LinkedIn"
        />
      </div>
      <div class="form-group">
        <textarea
          class="form-control"
          rows="3"
          v-model="message"
          placeholder="Insira a sua mensagem"
        ></textarea>
      </div>
      <div class="form-group">
        <label class="custom-file-upload" @click="$refs.file.click()">
          <i class="fa fa-cloud-upload"></i> {{ fileName }}
        </label>
        <input
          type="file"
          ref="file"
          @change="handleFileUpload()"
          accept=".pdf, .docx"
          required
        />
      </div>
      <div id="small">
        <small>*Campos Obrigatórios</small>
      </div>
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="check"
          required
        />
        <label class="form-check-label" for="exampleCheck1"
          >Li e aceito a
          <a href="" data-dismiss="modal"
            ><router-link to="/privacity"
              >Política de Privacidade e Proteção de Dados</router-link
            ></a
          ></label
        >
      </div>
      <button type="submit" class="btn btn">Enviar</button>
    </form>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Loading from "../components/Loading.vue";
import { mapGetters } from "vuex";
export default {
  components: { Multiselect, Loading },
  props: {
    id: Number,
  },
  data() {
    return {
      selected: null,
      options: [],
      name: "",
      email: "",
      cv: "",
      linkedin: "",
      skills: "",
      message: "",
      image: null,
      file: "",
      fileName: "Currículo (pdf/docx) máx. 10MB *",
      cellphone: "",
      check: false,
      isLoading: false,
      fullPage: false,
      load: false,
    };
  },
  created() {
    this.getAllSkills();
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.fileName = this.file.name;
    },
    async addCandidature() {
      if (
        this.file.type ==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        this.file.type == "application/pdf"
      ) {
        if (this.file.size < 10000000) {
          let id_skills = [];
          if (this.selected != null) {
            for (let i = 0; i < this.selected.length; i++) {
              id_skills.push(this.selected[i].value);
            }
          }
          this.load = true;
          try {
            await this.$store.dispatch("fetchApplications", {
              idJobs: this.id,
              name: this.name,
              email: this.email,
              cv: this.file,
              linkedin: this.linkedin,
              skills: id_skills,
              about: this.message,
              otherSkills: this.skills,
              cellphone: this.cellphone,
            });
            this.$swal({
              title: this.getMessage,
              text: this.getSubmessage,
              confirmButtonColor: "#f7941e",
              confirmButtonText: "Confirmar",
            });
            this.name = "";
            this.email = "";
            this.linkedin = "";
            this.selected = null;
            this.skills = "";
            this.message = "";
            this.cellphone = "";
            this.file = "";
            this.fileName = "Currículo (pdf/docx) máx. 10MB *";
            this.check = false;
          } catch (err) {
            this.$swal({
              title: `Pedimos desculpa, mas ocorreu um erro!`,
              text: `Por favor, volte a tentar mais tarde`,
              confirmButtonColor: "#f7941e",
              confirmButtonText: "Confirmar",
            });
          } finally {
            this.load = false;
          }
        } else {
          this.$swal({
            title: `Excedeu o tamanho do ficheiro`,
            text: `O seu ficheiro excedeu o tamanho máximo permitido`,
            confirmButtonColor: "#f7941e",
            confirmButtonText: "OK",
          });
        }
      } else {
        this.$swal({
          title: `Formato do currículo não autorizado`,
          text: `Mude o seu ficheiro do currículo`,
          confirmButtonColor: "#f7941e",
          confirmButtonText: "OK",
        });
      }
    },
    async getAllSkills() {
      try {
        await this.$store.dispatch("fetchSkills");
        for (let i = 0; i < this.getSkills.data.length; i++) {
          this.options.push({
            value: this.getSkills.data[i].id_skills,
            text: this.getSkills.data[i].name,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    ...mapGetters(["getSkills"]),
    ...mapGetters(["getMessage"]),
    ...mapGetters(["getSubmessage"]),
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border-bottom: 2px solid grey;
  display: inline-block;
  font-weight: bold;
  color: grey;
  font-size: 20px;
  margin-top: 10px;
  padding: 6px 12px;
  cursor: pointer;
}
form {
  padding: 0px 0px 0px 0px;
  text-align: center;
  cursor: auto;
}
.swal-title {
  font-family: "Courier New", Courier, monospace;
}
h1 {
  padding: 20px;
}
.form-control {
  font-weight: bold;
  border: 0px solid black;
  border-bottom: 2px solid grey;
  border-radius: 0px;
}
.form-control:focus {
  font-weight: bold;
  font-size: 20px;
  color: #f7941e;
  box-shadow: none;
  border-color: #f7941e;
}
textarea {
  resize: none;
}
.form-check {
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button {
  border: 0px;
  margin-top: 20px;
  background: #f7941e;
  color: white;
}
button:focus {
  box-shadow: none;
}
button:hover {
  box-shadow: #888888;
  background-color: #888888;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  color: white;
}
#small {
  text-align: left;
}
a {
  color: #f7941e;
}

@media (max-width: 1000px) {
  form {
    padding: 0px 0px 0px 0px;
    text-align: center;
  }
  h1 {
    padding: 0px 0px 20px 0px;
  }
  .form-check {
    text-align: center;
  }
  button {
    border: 0px;
    margin-top: 20px;
    background: #f7941e;
  }
}
</style>
